export default __webpack_public_path__ + "static/media/technical.8b6ff8be.svg";